import React from 'react'
import { docs_catalog_1, docs_catalog_2, docs_catalog_3, docs_catalog_4 } from '../../../../escalas/docs/docs.catalog'
import { Divider } from 'antd'
export default function DocsCalc({ docs }) {

    // Example of docs: {"cat1":[1,1,1,1,1],"cat2":[1,1,1,1,1],"cat3":[1,1,1,1,1],"cat4":[1,1,1,1,1],"_id":"6974147337d353fe89a9ffd5"}

    const sumCat1 = docs.cat1 ? docs.cat1.reduce((a, b) => a + b, 0) : 0
    const sumCat2 = docs.cat2 ? docs.cat2.reduce((a, b) => a + b, 0) : 0
    const sumCat3 = docs.cat3 ? docs.cat3.reduce((a, b) => a + b, 0) : 0
    const sumCat4 = docs.cat4 ? docs.cat4.reduce((a, b) => a + b, 0) : 0

    const TotalCategoria = ({ label, sum }) =>
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10, backgroundColor: '#e0e0e0', paddingRight: 10, borderRadius: 6 }}>
                <p style={{ fontWeight: 'bold', fontSize: 16, marginTop: 10 }}>{label}: {sum}</p>
            </div>
            <Divider style={{ margin: '20px 0' }} />
        </div>

    return (
        <div>
            {/* {JSON.stringify(docs)} */}
            <p style={{ fontWeight: 'bold', fontSize: 16 }}>Gérmenes y contaminación</p>
            {
                docs_catalog_1.map((obj, index) => {
                    return (
                        <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                            <td style={{ width: '60%' }}>{obj.pregunta}</td>
                            <td style={{ width: '36%' }}>{obj.respuestas[docs.cat1[index]]}</td>
                        </tr>
                    )
                })
            }

            <TotalCategoria label={"Total categoría Gérmenes y contaminación"} sum={sumCat1} />


            <p style={{ fontWeight: 'bold', fontSize: 16, marginTop: 10 }}>Causar daño, lesiones o mala suerte</p>
            {
                docs_catalog_2.map((obj, index) => {
                    return (
                        <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                            <td style={{ width: '60%' }}>{obj.pregunta}</td>
                            <td style={{ width: '36%' }}>{obj.respuestas[docs.cat2[index]]}</td>
                        </tr>
                    )
                })
            }

            <TotalCategoria label={"Total categoría Causar daño, lesiones o mala suerte"} sum={sumCat2} />

            <p style={{ fontWeight: 'bold', fontSize: 16, marginTop: 10 }}>Pensamientos inaceptables/prohibidos</p>
            {
                docs_catalog_3.map((obj, index) => {
                    return (
                        <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                            <td style={{ width: '60%' }}>{obj.pregunta}</td>
                            <td style={{ width: '36%' }}>{obj.respuestas[docs.cat3[index]]}</td>
                        </tr>
                    )
                })
            }

            <TotalCategoria label={"Total categoría Pensamientos inaceptables/prohibidos"} sum={sumCat3} />

            <p style={{ fontWeight: 'bold', fontSize: 16, marginTop: 10 }}>Simetría</p>
            {
                docs_catalog_4.map((obj, index) => {
                    return (
                        <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                            <td style={{ width: '60%' }}>{obj.pregunta}</td>
                            <td style={{ width: '36%' }}>{obj.respuestas[docs.cat4[index]]}</td>
                        </tr>
                    )
                })
            }

            <TotalCategoria label={"Total categoría Simetría"} sum={sumCat4} />

            <TotalCategoria label={"TOTAL GENERAL"} sum={sumCat1 + sumCat2 + sumCat3 + sumCat4} />

        </div>
    )
}
